export default "__VITE_ASSET__6Uj6XX1$__"